module.exports = __webpack_public_path__ + "assets/img/home_cs_6.20dd2560.png";